export default __webpack_public_path__ + "static/media/1.42c0b2db.jpg";